$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector("#reviews").scrollIntoView({
    behavior: "smooth",
  });
});
$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector(".product_main_lp").scrollIntoView({
    behavior: "smooth",
  });
});

function isScrolledIntoView(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();
  docViewBottom =
    docViewBottom - $(window).height() / 2 + $(elem).height() + 100;
  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height();

  return elemBottom <= docViewBottom;
}

$(window).scroll(function () {
  $(".behind_lp_steps .icons_with_text_flex").each(function () {
    if (isScrolledIntoView(this) === true) {
      $(this).addClass("active");
    } else {
      $(this).removeClass("active");
    }
  });
});

jQuery(document).ready(function () {
  if (navigator.userAgent.indexOf("Mac") > 0) {
    jQuery("body").addClass("mac-os");
  }
});
